import GenerateText, { GenerateTextProps } from './GenerateText';

export type { GenerateTextProps };
export default GenerateText;
